import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ImportSettingsService } from '../import-settings/import-settings.service';
import { T2LoadingService } from '../../trip2-theme/components/t2-loading/t2-loading.service';
import { GridOptions } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ParentModule } from '../A2-utils/ParentClass/parent-module';

@Component({
  selector: 'app-import-template',
  templateUrl: './import-template.component.html',
  styleUrls: ['./import-template.component.scss']
})
export class ImportTemplateComponent extends ParentModule implements OnInit {

  public titleImport = 'Create Import Template';
  public titleFile = 'View File';
  public classbutton = 'btn-success';
  public form: FormGroup;
  public jsonDataForm: any;
  public rules: any[];
  public rulesFx: any[];
  private step1= true;
  private step2= false;
  private next1= false;
  public cancelCharge: any;
  public showFunction= false;
  public position: number;
  public dataFormFunctions: any;
  public validForm: boolean;
  public viewFile: any[];
  public showFileImport = false;
  public gridImport: GridOptions;

  constructor(
    private fb: FormBuilder,
    private _importSevice: ImportSettingsService,
    protected _loading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
    protected Inject: Injector
  ) {
    super('app-import-template', Inject)
    this.gridImport = <GridOptions>{};
    this.gridImport.enableColResize = true;
  }

  ngOnInit() {
    this.createForm();
  }


  /**
   * @Metodo createForm
   * @description Para crear el formulario
   * */
  createForm() {
    this.form = this.fb.group({
      sourceColumns: [[], [Validators.required]],
      settings: [{}, [Validators.required]],
      rules: [[], [Validators.required]]
    });
    this.listenToForm();
  }

  /**
   * @Metodo listenToForm
   * @description Para escuchar los cambios del formulario
   * */
  listenToForm() {
    this.validForm = false;
    this.form.valueChanges.subscribe( val => {
      if (this.form.valid) {this.validForm = true; }
    });
  }

  /**
   * @Metodo nextStep
   * @description Para avanzar al siguiente paso
   * */
  nextStep() {
    if (this.step1) {
      this.step1 = false;
      this.step2 = true;
      this.titleImport = 'Column Selection';
    }
  }

  /**
   * @Metodo backStep
   * @description Para retroceder.
   * */
  backStep() {
    if (this.step2) {
      this.step2 = false;
      this.step1 = true;
      this.titleImport = 'Create Import Template';
      this.showFile();
    }
  }

  /**
   * @Metodo nextForm
   * @description Para llenar el formulario padre del Step1
   * */
  nextForm(event) {
    if (event) {
      this.next1 = true;
      this.jsonDataForm = event;
      this.form.patchValue(event);
    } else {
      this.next1 = false;
      // this.form.reset();
    }
  }

  /**
   * @Metodo loadForm
   * @description Para pasar datos el formulario Step2
   * */
  loadForm(event) {
    this.rules = event;
    this.rulesFx = event;
  }

  /**
   * @Metodo cancelForm
   * @description
   * */
  cancelForm() {
    this.cancelCharge = true;
    this.next1 = false;
    this.step2 = false;
    this.step1 = true;
    this.showFunction = false;
    this.validForm = false;
    this.position = undefined;
    this.titleImport = 'Create Import Template';
  }

  /**
   * @Metodo selectFunction
   * @description
   * */
  selectFunction(i) {
    i === undefined ? this.showFunction = false : this.showFunction = true;
    this.position = i;
  }

  /**
   * @Metodo createImport
   * @description para asignar el nombre y llamar al metodo sendData
   * */
  createImport() {
    const form = this.form.getRawValue();
    const data = {
      description: 'name',
      setting:  JSON.stringify(form)
    };
    this.sweetAlertHelper.createCustomAlert({
      title: 'Import Template',
      text: 'Enter name',
      input: 'text',
      confirmButtonText: 'Create Template',
    }).then((resul) => {
      data.description = resul.value;
      this.sendData(data);
    });
  }

  /**
   * @Metodo sendData
   * @description para enviar el Json completo.
   * */
  sendData(data) {
    this._loading.show();
    this._importSevice.createTemplateImport(data)
      .finally(() => {
        this._loading.hiden();
      })
      .subscribe( success => {
        this.sweetAlertHelper.createCustomAlert({
            title: 'Create Template ' + data.description,
            text: data.description + ' creation was successful',
          }
        );
        this.cancelForm();
      },
        error => {
          this.sweetAlertHelper.createCustomAlert({
            text: 'Create Template',
            type: 'error',
          });
        });
  }

  /**
   * @Metodo defineColumnDefs
   * @description para definir las columnas dinamicamente.
   * */
  defineColumnDefs(value) {
    const columns = [];
    value.forEach( val => {
      columns.push(
        {
          headerName: val,
          field: val,
          width: 90
        }
      );
    });
    return columns;
  }

  /**
   * @Metodo viewFileImport
   * @description para pasar la informacion del file a la vista
   * */
  viewFileImport(event) {
    event[1].splice(20);
    this.gridImport.columnDefs = this.defineColumnDefs(event[0]);
    this.viewFile = event[1];
  }

  /**
   * @Metodo showFile
   * @description para mostrar el file
   * */
  showFile() {
    this.showFileImport = !this.showFileImport;
    this.showFileImport ? this.titleFile = 'Close File' : this.titleFile = 'View File';
    this.showFileImport ? this.classbutton = 'btn-danger' : this.classbutton = 'btn-success';
  }


  /**
   * @Metodo functionColumn
   * @description
   * */
  functionColumn(event) {
    if ( this.position !== undefined) {
      this.dataFormFunctions = [event, this.position];
      if (this.showFunction = true)  {
        this.showFunction = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/import-template.component.ts